<template>
  <div class="main">
    <screen-header
      :updateTime="updateTime"
      @update-data="updateData"
    ></screen-header>
    <div class="main-content">
      <div class="city-basic">
        <div class="city-basic-title">
          <img src="../../assets/big-screen/city-basic-left.png" alt="" />
          <span class="city-basic-title-font">全市基本情况统计</span>
          <img src="../../assets/big-screen/city-basic-right.png" alt="" />
        </div>
        <div class="city-basic-data">
          <el-row>
            <el-col :span="6">
              <span>县市区</span>
              <p style="margin-top: 10px">
                <span class="data-font">{{ cities.length - 2 || 0 }}</span>
                <span>个</span>
              </p>
            </el-col>
            <el-col :span="6">
              <span>学校</span>
              <p style="margin-top: 10px">
                <span class="data-font">{{ basicData.schoolCount || 0 }}</span>
                <span>所</span>
              </p>
            </el-col>
            <el-col :span="6">
              <span>班级(总数)</span>
              <p style="margin-top: 10px">
                <span class="data-font">{{
                  basicData.totalClassCount || 0
                }}</span>
                <span>个</span>
              </p>
            </el-col>
            <el-col :span="6" v-if="!$regional.HengshuiYanshou">
              <span>班级(55人以上)</span>
              <p style="margin-top: 10px">
                <span class="special-data-font">{{
                  basicData.largeClassCount || 0
                }}</span>
                <span>个</span>
              </p>
            </el-col>
          </el-row>
          <el-row style="margin-top: 40px">
            <el-col :span="6">
              <span>教师</span>
              <p style="margin-top: 10px">
                <span class="data-font">{{ basicData.teacherCount || 0 }}</span>
                <span>人</span>
              </p>
            </el-col>
            <el-col :span="6">
              <span>学生</span>
              <p style="margin-top: 10px">
                <span class="data-font">{{ basicData.studentCount || 0 }}</span>
                <span>人</span>
              </p>
            </el-col>
            <el-col :span="6">
              <span>男生</span>
              <p style="margin-top: 10px">
                <span class="data-font">{{ basicData.boyCount || 0 }}</span>
                <span>人</span>
              </p>
            </el-col>
            <el-col :span="6">
              <span>女生</span>
              <p style="margin-top: 10px">
                <span class="data-font">{{ basicData.girlCount || 0 }}</span>
                <span>人</span>
              </p>
            </el-col>
          </el-row>
        </div>
        <div class="charts">
          <div id="main" style="width: 25vw"></div>
          <div class="rest-city">
            <el-button @click="clickCity('市直属')">市直属</el-button>
            <el-button @click="clickCity('滨湖新区')">滨湖新区</el-button>
            <el-button @click="clickCity('高新区')">高新区</el-button>
          </div>
        </div>
      </div>
      <div class="stage-basic">
        <div class="stage-basic-title">
          <img src="../../assets/big-screen/city-basic-left.png" alt="" />
          <span class="city-basic-title-font">全市 各学段基本情况统计</span>
          <img src="../../assets/big-screen/city-basic-right.png" alt="" />
        </div>
        <div class="top-select">
          <div class="stage-select">
            <div style="line-height: 18px">
              <span>选择学段：</span>
              <span
                :class="
                  stage === item.value ? 'school-stage active' : 'school-stage'
                "
                v-for="item in stages"
                :key="item.value"
                @click="changeStage(item)"
                >{{ item.name }}</span
              >
            </div>
            <div style="margin-top: 20px; line-height: 18px">
              <span>选择区域：</span>
              <span
                :class="
                  city === item.value ? 'school-stage active' : 'school-stage'
                "
                v-for="item in cities"
                :key="item.value"
                @click="changeCity(item)"
                >{{ item.name }}</span
              >
            </div>
          </div>
          <div class="stage-data">
            <el-row>
              <el-col :span="3">
                <span>学校</span>
                <p style="margin-top: 10px">
                  <span class="data-font">{{ pageData.schoolCount || 0 }}</span>
                  <span>所</span>
                </p>
              </el-col>
              <el-col :span="3">
                <span>班级(总数)</span>
                <p style="margin-top: 10px">
                  <span class="data-font">{{
                    pageData.totalClassCount || 0
                  }}</span>
                  <span>个</span>
                </p>
              </el-col>
              <el-col :span="3" v-if="!$regional.HengshuiYanshou">
                <span>班级(55人以上)</span>
                <p style="margin-top: 10px">
                  <span class="special-data-font">{{
                    pageData.largeClassCount || 0
                  }}</span>
                  <span>个</span>
                </p>
              </el-col>
              <el-col :span="3">
                <span>教师</span>
                <p style="margin-top: 10px">
                  <span class="data-font">{{
                    pageData.teacherCount || 0
                  }}</span>
                  <span>人</span>
                </p>
              </el-col>
              <el-col :span="4">
                <span>学生</span>
                <p style="margin-top: 10px">
                  <span class="data-font">{{
                    pageData.studentCount || 0
                  }}</span>
                  <span>人</span>
                </p>
              </el-col>
              <el-col :span="4">
                <span>男生</span>
                <p style="margin-top: 10px">
                  <span class="data-font">{{ pageData.boyCount || 0 }}</span>
                  <span>人</span>
                </p>
              </el-col>
              <el-col :span="4">
                <span>女生</span>
                <p style="margin-top: 10px">
                  <span class="data-font">{{ pageData.girlCount || 0 }}</span>
                  <span>人</span>
                </p>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="table">
          <el-row>
            <el-col :span="24">
              <el-table
                :data="pageData.schoolSummaryList"
                size="medium"
                border
                :header-row-style="{ color: '#fff' }"
                :row-style="{ height: '40px' }"
                class="home-table"
              >
                <el-table-column prop="index" label="序号" width="80">
                  <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                  </template>
                </el-table-column>
                <el-table-column
                  v-if="city"
                  prop="schoolName"
                  label="学校名称"
                ></el-table-column>
                <el-table-column
                  v-if="!city"
                  prop="regionName"
                  label="区县名称"
                ></el-table-column>
                <el-table-column
                  v-if="!city"
                  prop="schoolNumber"
                  label="学校（总数）"
                ></el-table-column>
                <el-table-column
                  prop="totalClassCount"
                  label="班级(总数)"
                ></el-table-column>
                <el-table-column
                  v-if="!$regional.HengshuiYanshou"
                  prop="largeClassCount"
                  label="班级(55人以上)"
                ></el-table-column>
                <el-table-column
                  prop="teacherCount"
                  label="教师数"
                ></el-table-column>
                <el-table-column
                  prop="studentCount"
                  label="学生数"
                ></el-table-column>
                <el-table-column
                  prop="boyCount"
                  label="男生数"
                ></el-table-column>
                <el-table-column
                  prop="girlCount"
                  label="女生数"
                ></el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </div>
        <el-row class="screen-pagination-row screen-pagination">
          <el-col :span="24">
            <el-pagination
              v-if="city"
              :total="total"
              :current-page.sync="page"
              :page-sizes="[10, 20, 100]"
              :page-size.sync="size"
              layout="prev, pager, next, sizes, jumper"
              @current-change="
                val => initStageData(this.stage, this.city, val, this.size)
              "
              @size-change="handleSizeChange"
            >
            </el-pagination>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import ScreenHeader from '@/components/big-screen/ScreenHeader'

const districtOrderArr = [
  {
    name: '桃城区',
    value: null
  },
  {
    name: '冀州区',
    value: null
  },
  {
    name: '枣强县',
    value: null
  },
  {
    name: '武邑县',
    value: null
  },
  {
    name: '深州市',
    value: null
  },
  {
    name: '武强县',
    value: null
  },
  {
    name: '饶阳县',
    value: null
  },
  {
    name: '安平县',
    value: null
  },
  {
    name: '故城县',
    value: null
  },
  {
    name: '景县',
    value: null
  },
  {
    name: '阜城县',
    value: null
  },
  {
    name: '高新区',
    value: null
  },
  {
    name: '滨湖新区',
    value: null
  },
  {
    name: '市直属',
    value: null
  }
]
export default {
  props: [],

  components: {
    ScreenHeader
  },

  data() {
    return {
      stage: null,
      basicData: {},
      stages: [
        {
          name: '全部',
          value: null
        },
        {
          name: '小学',
          value: 1
        },
        {
          name: '初中',
          value: 2
        },
        {
          name: '高中',
          value: 3
        },
        {
          name: '教学点',
          value: 7
        },
        {
          name: '九年一贯制',
          value: 4
        },
        {
          name: '十二年一贯制',
          value: 5
        },
        {
          name: '完全中学',
          value: 6
        },
        {
          name: '职教中心',
          value: 8
        }
      ],
      city: null,
      cities: [],
      pageData: {},
      size: 10,
      page: 1,
      total: 0,
      updateTime: ''
    }
  },

  watch: {},

  computed: {},

  mounted() {
    this.initData()
    this.initStageData(this.stage, this.city, 1, 10)
    this.$generateEchartsPie('main')
    this.clickPie()
  },

  methods: {
    initData(stage, city, page, size) {
      this.page = page
      this.size = size
      // 更新时间
      this.$xhrGet(`/acc/summary/update/time`).then(rs => {
        this.updateTime = rs.data
      })
      // 全市基本情况统计
      this.$xhrGet(`/acc/summary/general`).then(rs => {
        this.basicData = rs.data
      })
      // 区域列表
      this.$xhrGet(`/acc/summary/regions`).then(rs => {
        this.cities = []
        for (let index = 0; index < rs.data.length; index++) {
          let element = rs.data[index]
          let targetDis = _.filter(districtOrderArr, { name: element.name })
          if (targetDis && targetDis.length > 0) {
            targetDis[0].value = element.value
          }
        }
        let districtArr = _.cloneDeep(districtOrderArr)
        districtArr.unshift({
          name: '全部',
          value: null
        })
        this.cities = _.cloneDeep(districtArr)
      })
    },

    updateData() {
      this.stage = this.stages[0].value
      this.city = this.cities[0].value
      this.page = 1
      this.size = 10
      this.$xhrGet(`/acc/summary/update`).then(rs => {
        if (rs.code === 'SUCCESS') {
          this.initData(this.stage, this.city, 1, 10)
          this.initStageData(this.stage, this.city, 1, 10)
        }
      })
    },

    initStageData(stage, city, page, size) {
      // 首页其他数据
      let param = {
        regionId: city,
        schoolStage: stage,
        page: page,
        size: size
      }
      this.$xhrGet(`/acc/summary/school-stage`, param).then(rs => {
        this.pageData = rs.data
        this.total = rs.data.total || 0
      })
    },

    clickPie() {
      var myChart = this.$generateEchartsPie('main')
      let that = this
      myChart.on('click', item => {
        let city = _.filter(that.cities, { name: item.name })
        if (city.length > 0) {
          that.$router.push({
            name: 'DistrictAnalysis',
            query: { city: item.name, val: city[0].value }
          })
        } else {
          that.$message.error('跳转失败，区域数据错误')
        }
      })
    },

    clickCity(city) {
      let clickCity = _.filter(this.cities, { name: city })
      if (clickCity.length > 0) {
        this.$router.push({
          name: 'DistrictAnalysis',
          query: { city: city, val: clickCity[0].value }
        })
      } else {
        this.$message.error('跳转失败，区域数据错误')
      }
    },

    changeStage(item) {
      this.page = 1
      this.size = 10
      this.stage = item.value
      this.initData(this.stage, this.city, this.page, this.size)
      this.initStageData(this.stage, this.city, this.page, this.size)
    },

    changeCity(item) {
      this.page = 1
      this.size = 10
      this.city = item.value
      this.initData(this.stage, this.city, this.page, this.size)
      this.initStageData(this.stage, this.city, this.page, this.size)
    },

    handleSizeChange(val) {
      this.size = val
      this.page = 1
      this.initStageData(this.stage, this.city, this.page, this.size)
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  width: 100%;
  height: 100%;
  position: relative;
  background: url("../../assets/big-screen/bg.png") center no-repeat;
  background-size: 100% 100%;
  filter: saturate(0.7);
}
.title {
  width: 100%;
  height: 4.2vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background: url("../../assets/big-screen/title.png") center no-repeat;
  background-size: 100% 100%;
}
.title-font {
  color: #fff;
  font-size: 1.8vw;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  line-height: 50px;
}
.title-font:before {
  content: attr(text);
  position: absolute;
  z-index: 10;
  color: #43f9ff;
  mask: linear-gradient(to top, #43f9ff, transparent);
}
.update {
  position: absolute;
  top: 0.7vw;
  right: 30px;
  color: #43f9ff;
  font-size: 0.7vw;
}
.update-button {
  display: inline-block;
  margin-left: 20px;
  padding: 4px 12px;
  border-radius: 32px;
  border: 1px solid #43f9ff;
  cursor: pointer;
}
.main-content {
  width: calc(100% - 80px);
  height: calc(100% - 80px - 4.2vw);
  padding: 40px;
}
.city-basic {
  float: left;
  width: 26vw;
  height: 100%;
  background: url("../../assets/big-screen/home-left-bg.png") center no-repeat;
  background-size: 100% 100%;
}
.stage-basic {
  float: right;
  width: calc(100% - 26vw - 40px);
  height: 100%;
  margin-left: 40px;
  background: url("../../assets/big-screen/home-right-bg.png") center no-repeat;
  background-size: 100% 100%;
}
.stage-basic-title {
  height: 30px;
  margin-top: 30px;
  text-align: center;
  vertical-align: middle;
}
.city-basic-title {
  height: 30px;
  margin-top: 30px;
  text-align: center;
  vertical-align: middle;
}
.city-basic-title-font {
  display: inline-block;
  margin: 0 12px;
  font-size: 1.25vw;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #41f9ff;
}
.city-basic-data {
  margin-top: 45px;
  padding: 0 30px;
  font-size: 0.8vw;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
}
.data-font {
  font-size: 1.25vw;
  font-family: DIN-Medium, DIN;
  font-weight: 500;
  color: #3df9ff;
}
.special-data-font {
  font-size: 1.25vw;
  font-family: DIN-Medium, DIN;
  font-weight: 500;
  color: #ff6666;
}
.top-select {
  width: calc(100% - 120px);
  height: 180px;
  margin: 30px 40px 15px 40px;
  padding: 20px;
  background-color: rgba(35, 113, 232, 0.37);
  border-radius: 2px;
  font-size: 0.8vw;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
}
.school-stage {
  padding-right: 15px;
  cursor: pointer;
}
.stage-select {
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}
.stage-select .active {
  color: #43f9ff;
}
.stage-data {
  padding: 30px;
}
.table {
  height: calc(100% - 417px);
  overflow: auto;
  border-radius: 2px;
  margin: 30px 40px 15px 40px;
  background-color: rgba(35, 113, 232, 0.37);
}
.screen-pagination {
  margin: 10px 40px 15px 40px;
}
/deep/ .el-table {
  background-color: rgba(35, 113, 232, 0.17);
  color: #fff;
}
.el-table /deep/ tr,
.el-table /deep/ th,
/deep/ .cell {
  background-color: transparent !important;
}
// /deep/ tr {
//   pointer-events: none;
// }
/deep/ .el-table__body tr:hover > td {
  background-color: rgba(35, 113, 232, 0.17) !important;
}
/deep/ .el-table__body tr.hover-row > td {
  background-color: rgba(35, 113, 232, 0.37) !important;
}
.el-pagination /deep/ .el-input__inner {
  background-color: transparent;
  color: #fff;
}
.el-pagination /deep/ li {
  margin: 0 10px;
  background: #0f3b7d;
  color: #fff;
}
.el-pagination /deep/ li.active {
  color: #fff;
  background: #2371e8;
  cursor: default;
}
.el-pagination /deep/ .btn-prev {
  background: #0f3b7d;
  color: #fff;
}
.el-pagination /deep/ .btn-next {
  background: #0f3b7d;
  color: #fff;
}
.charts {
  margin-top: 5vh;
  height: calc(100% - 277px - 5vh);
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.rest-city {
  position: absolute;
  top: 4.8vh;
  left: 10px;
  display: flex;
  align-items: center;
  flex-direction: column;
  .el-button {
    width: 4.7vw;
    min-width: 52px;
    margin-bottom: 10px;
    background-color: #184e9d;
    font-size: 0.8vw;
    color: #fff;
    margin-left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
/deep/ .el-table {
  border-color: transparent !important;
}
.home-table /deep/ td {
  border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
  border-right: 1px solid rgba(255, 255, 255, 0.12) !important;
}
.home-table /deep/ th {
  border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
  border-right: 1px solid rgba(255, 255, 255, 0.12) !important;
}
// 去掉表格单元格边框
/deep/ .home-table th {
  border: none;
}
/deep/ .home-table td,
.home-table th.is-leaf {
  border: none;
}
// 表格最外边框
/deep/ .el-table--border,
.el-table--group {
  border: none;
}
// 头部边框
/deep/ .home-table thead tr th.is-leaf {
  border: none;
}
/deep/ .home-table thead tr th:nth-last-of-type(2) {
  border: none;
}
// 表格最外层边框-底部边框
/deep/ .el-table--border::after,
.el-table--group::after {
  width: 0;
}
/deep/ .home-table::before {
  width: 0;
}
/deep/ .home-table .el-table__fixed-right::before,
.el-table__fixed::before {
  width: 0;
}
// 表格有滚动时表格头边框
/deep/ .el-table--border th.gutter:last-of-type {
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/big-screen/Index.vue